<template>
  <div id="cate">
    <div class="rightContent">
      <div class="listBlock">
        <el-table :data="catelist" style="width: 100%">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="cate" label="分类名称"></el-table-column>
          <el-table-column prop="ordernu" label="排序"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i @click="sortOrder(scope.row.id, 1)" class="el-icon-sort-up"></i>
              <i @click="sortOrder(scope.row.id, -1)" class="el-icon-sort-down"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cate",
  data() {
    return {
      doing: false,
      catelist: ''
    };
  },
  computed: {},
  created() {
    this.getCate()
    this.resizedwindow()
  },
  methods: {
    getCate() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {}
      this.axios
        .post("/kaiSrv/mgr/cateList", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.catelist = response.data.list;
          }
        });
    },
    sortOrder(id, ordertype) {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        id: id,
        ordertype: ordertype
      }
      this.axios
        .post("/kaiSrv/mgr/sortOrder", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.getCate()
          }
        });
    }
  }
};
</script>
<style  lang="scss">
#cate {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .el-pagination .el-input__inner {
    width: 0.9rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.2rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped lang="scss">
#cate {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #409EFF;
      border: 1px solid #409EFF;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cate.vue